import type React from 'react';

import type { SessionUser } from 'src/shared/session';

import { GoogleAuthButton } from 'src/app/shared/components/buttons';

import { useGoogleButton } from './hooks/useGoogleButton';

type Props = {
	onError: (err: string) => void;
	onSuccess: (user: SessionUser) => void;
};

export const GoogleButton: React.FC<Props> = ({ onSuccess, onError }) => {
	const {
		actions: { handleSuccess, handleFailure },
	} = useGoogleButton({ onSuccess, onError });

	return (
		<GoogleAuthButton onSuccess={handleSuccess} onError={handleFailure} loginType="payment" signupContext="payment" />
	);
};
